import { render, staticRenderFns } from "./MyGiftCard.vue?vue&type=template&id=56e2b735&scoped=true"
import script from "./MyGiftCard.vue?vue&type=script&lang=js"
export * from "./MyGiftCard.vue?vue&type=script&lang=js"
import style0 from "./MyGiftCard.vue?vue&type=style&index=0&id=56e2b735&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e2b735",
  null
  
)

export default component.exports